<template>
  <div>Ben Düzenleyim {{this.$route.params.Fatura_id}}</div>
</template>

<script>
    export default {
        name: "duzenle",

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/gider/fatura/duzenle.vue